// Recorder brands the edge agent can actually drive — the shobdo-agent recorder
// drivers are dahua_nvr and hikvision_nvr (Dahua covers Amcrest). Keep in sync with
// agent/discovery/fetchers.py.
export const NVR_BRANDS = ["Dahua", "Hikvision"] as const;
